{
  "manage_actions_page": {
    "manage_billing": {
      "title": "Manage Billing",
      "description": "Manage the billing for {name}"
    },
    "manage_team": {
      "title": "Manage Team",
      "description": "Manage team {name}"
    },
    "load_error": "There was a problem loading these actions.",
    "no_actions": "There are no actions available for this team.",
    "unavailable_heading": "Unavailable Actions",
    "unavailable_description": "The following actions are not available at this time for this team",
    "footer": "Learn more about staff tools"
  },
  "view_action_page": {
    "title": "{prefix} — {name}",
    "footer": "Learn more about staff tools",
    "confirm": "Confirm",
    "no_longer_available": "This action is no longer available for this team",
    "load_error": "There was a problem loading this action",
    "success": "The {name} action completed successfully.",
    "invalid_request": "{name} Action - Invalid request",
    "unable_to_complete": "{name} Action - Unable to complete action",
    "failed": "{name} Action - There was an issue completing this action."
  }
}
